<template>
  <div>
    <EtsyRankHead
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeFilter="changeFilter"
        :showFilter="showFilter"
        :activeTab="activeTab"
        @changeTab="changeTab"
    />

    <div class="table-filter-wrap">

      <EtsyRankFilter
          :showFilter="showFilter"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
      />

      <EtsyRankTable
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          :activeTab="activeTab"
      />
    </div>
  </div>
</template>

<script>


  import EtsyRankHead from "./EtsyRankHead/EtsyRankHead";
  import EtsyRankTable from "./EtsyRankTable/EtsyRankTable";
  import EtsyRankFilter from "./EtsyRankFilter/EtsyRankFilter";

  export default {
    name: "EtsyRankCardTable",

    components: {
      EtsyRankHead,
      EtsyRankTable,
      EtsyRankFilter,
    },

    props: [
      'typeShops',
      'filterGetParams',
      'countFilterParams',
    ],

    data(){
      return{
        showFilter: false,
        filterId: '',
        filterName: '',
        forPage: 10,
        page: 1,
        activeTab: 1,

        isModalCommentsPopup: '',
        isModalSendEmailPopup: '',
        isModalLastFiveIPPopup: '',
        isModalStatisticPopup: '',
      }
    },

    watch: {
      typeShops(newVal) {
        this.typeShops = newVal
      },
      filterGetParams(newVal) {
        this.filterGetParams = newVal
      },
      countFilterParams(newVal) {
        this.countFilterParams = newVal
      },
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },


      changeFilter(data) {
        this.$emit('changeFilter', data)
      },

      selectAll(val) {
        this.selectedNow = val
      },

      changeCommentsPopup(val){
        this.isModalCommentsPopup = val
      },
      changeSendEmailPopup(val){
        this.isModalSendEmailPopup = val
      },
      changeLastFiveIPPopup(val){
        this.isModalLastFiveIPPopup = val
      },
      changeStatisticPopup(val){
        this.isModalStatisticPopup = val
      },

      changeTab(id) {
        this.activeTab = id
      },
    }
  }
</script>

<style scoped>

</style>


